import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import Loader from "../../components/ui/Loader";
import { redirectToUrl } from "../../utils/utils";

// const portalLink = null;
const portalLink = process.env.REACT_APP_PORTAL_URL;

export default function KeycloakSignIn() {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (!keycloak.authenticated) {
      localStorage.clear();
      if (portalLink) {
        redirectToUrl(portalLink + "/sign-in");
      } else {
        keycloak.login({ redirectUri: window.location.origin + "/" });
      }
    }
  }, [keycloak]);

  return <Loader />;
}